function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBtnResetFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("g", {
  style: {
    fill: "#fff"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 31.5c-4.14 0-8.033-1.612-10.96-4.54A15.4 15.4 0 0 1 .5 16c0-4.14 1.612-8.033 4.54-10.96A15.4 15.4 0 0 1 16 .5c4.14 0 8.033 1.612 10.96 4.54A15.4 15.4 0 0 1 31.5 16c0 4.14-1.612 8.033-4.54 10.96A15.4 15.4 0 0 1 16 31.5",
  style: {
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 1C11.993 1 8.227 2.56 5.393 5.393A14.9 14.9 0 0 0 1 16c0 4.007 1.56 7.773 4.393 10.607A14.9 14.9 0 0 0 16 31c4.007 0 7.773-1.56 10.607-4.393A14.9 14.9 0 0 0 31 16c0-4.007-1.56-7.773-4.393-10.607A14.9 14.9 0 0 0 16 1m0-1c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0",
  style: {
    fill: "#e9e9e9",
    stroke: "none"
  }
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 829"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.73 13.461a6.7 6.7 0 0 1-3.563-1.019l.572-.777A5.769 5.769 0 0 0 11.37 3.3l.753-.6A6.731 6.731 0 0 1 6.73 13.461zm-5.4-2.707a6.732 6.732 0 0 1 8.942-9.745l-.808.645A5.769 5.769 0 0 0 1.935 9.94l-.6.814z",
  "data-name": "Subtraction 17",
  style: {
    fill: "#262626",
    stroke: "#262626",
    strokeWidth: ".1px"
  },
  transform: "translate(9.19 9.118)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m2.428 3.156-.118.1L0 .538.65 0l1.779 2.089L4.206 0l.65.538-2.31 2.716z",
  "data-name": "Union 64",
  style: {
    fill: "#262626",
    stroke: "#262626",
    strokeWidth: ".1px"
  },
  transform: "rotate(-29 40.062 -4.973)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.429 1.165.65 3.254 0 2.715 2.31 0l.118.1.118-.1 2.31 2.715-.65.538z",
  "data-name": "Union 65",
  style: {
    fill: "#262626",
    stroke: "#262626",
    strokeWidth: ".1px"
  },
  transform: "rotate(-29 34.324 -29.172)"
})));
export default SvgBtnResetFilter;